<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="page-title">
                    <span class="t-link" @click="$router.push('/equipment-list').catch(() => { })">{{ $t("Equipments")
                        }}</span> /
                    {{ $t("Register") }}
                </h5>
            </b-col>
        </b-row>
        <br>
        <b-row>
            <b-col>
                <b-card class="bg-t-dark default-form">
                    <b-row>
                        <b-col>
                            <h5>
                                {{ $t("Fill in the fields below to register a new equipment") }}:
                            </h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-row>
                                <b-col>
                                    <small>{{ $t("Model") }}:</small>
                                </b-col>
                            </b-row>
                            <b-row class="mt-1">
                                <b-col id="model-select">
                                    <b-form-select class="form-control form-select" v-model="model"
                                        :disabled="models.length < 1"
                                        :placeholder="models.length < 1 ? 'Carregando...' : 'Selecione'">
                                        <b-form-select-option v-for="m in models" :key="m.id" :value="m.id" v-if="m.id">
                                            {{ m.name }}
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col>
                                    <small>{{ $t("Regulatory mode") }}:</small>
                                </b-col>
                            </b-row>
                            <b-row class="mt-1">
                                <b-col id="regulatory-select">
                                    <b-form-select :disabled="!model || regulatory_agencies.length < 1"
                                        @click="getRegulatory" class="form-control form-select" placeholder="Selecione"
                                        v-model="regulatory_agency">
                                        <!-- <b-form-select-option :value="null">Please select an option</b-form-select-option> -->
                                        <b-form-select-option v-for="m in regulatory_agencies" :key="m.id" :value="m.id"
                                            v-if="m.id">
                                            {{ m.name }}
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4" v-show="false">
                            <b-row>
                                <b-col>
                                    <small>{{ $t("Preset") }}:</small>
                                </b-col>
                            </b-row>
                            <b-row class="mt-1">
                                <b-col id="preset-select">
                                    <b-form-select class="form-control form-select" v-model="preset"
                                        :disabled="presets.length < 1"
                                        :placeholder="presets.length < 1 ? $t('Loading...') : $t('Select')">
                                        <b-form-select-option v-for="p in presets" :key="p.id" :value="p.name">
                                            {{ p.name }}
                                            <span v-if="p.description"> — {{ p.description }}</span>
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col>
                            <b-btn id="identity-file-btn" variant="outline-t-blue" @click="select_file">
                                <b-icon-upload />
                                &nbsp;
                                {{ $t("Identity file") }}
                            </b-btn>
                            <b-popover target="identity-file-btn" triggers="hover" placement="right"
                                custom-class="file-specs-popover">
                                <template #title>
                                    {{ $t("File specifications") }}
                                </template>

                                <div>
                                    <p class="mb-2">
                                        {{ $t("The file must be in .json format with the following structure") }}:
                                    </p>
                                    <ul class="pl-4 mb-0">
                                        <li>{{ $t("Contains 'device' object or keys at root") }}</li>
                                        <li>{{ $t("All keys below must not be empty") }}:</li>
                                    </ul>
                                    <ul class="pl-5 mt-1" style="list-style-type: disc;">
                                        <li><code>equipment_serial_number</code></li>
                                        <li><code>pim_serial_number</code></li>
                                        <li><code>am_serial_number</code></li>
                                        <li><code>ventilation_board_serial_number</code></li>
                                    </ul>
                                </div>
                            </b-popover>

                            &nbsp;
                            &nbsp;
                            <span class="nowrap">
                                <span class="t-link">
                                    {{ file_name }}
                                </span>
                                &nbsp;
                                <span class="t-link" v-if="file_name" @click="resetForm">
                                    <b-icon-x />
                                </span>
                            </span>
                        </b-col>
                    </b-row>

                    <br>
                    <b-row v-if="json_data">
                        <b-col>
                            <h5>{{ $t("Confirm data to continue") }}:</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <form class="input-hidden" id="jsonfileform">
                                <input type="file" id="jsonfileinput" @change="json_file_handle" />
                            </form>
                            <b-row no-gutters>
                                <b-col md="6" v-for="(v, key) in json_data" :key="key">
                                    <b-row class="bg-gray margin-json-data">
                                        <b-col>
                                            <small>{{ key }}: {{ v }}</small>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row align="end" align-h="end">
                        <b-col align="end">
                            <b-btn variant="t-blue" @click="register" :disabled="!json_data" id="register-btn">
                                {{ $t("Register") }}
                            </b-btn>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-modal :id="'register-success'" hide-footer centered size="md" no-close-on-backdrop no-close-on-esc
            hide-header-close>
            <template #modal-title>
                &nbsp;
            </template>
            <div>
                <b-row class="text-center">
                    <b-col align="center">
                        <svg width="120" height="120" viewBox="0 0 120 120" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="1" y="1" width="118" height="118" rx="49" fill="white" stroke="#C0C0C0"
                                stroke-width="2" />
                            <path
                                d="M51.3802 71.9526L38.0473 58.6189L33.3333 63.333L51.3802 81.3807L88.0468 44.7141L83.3328 40L51.3802 71.9526Z"
                                fill="#1F8B24" />
                        </svg>
                    </b-col>
                </b-row>
                <br>
                <b-row class="text-center mt-3">
                    <b-col>
                        <b>{{ $t("Equipment registered successfully") }}!</b>
                    </b-col>
                </b-row>
                <b-row class="text-center mt-3">
                    <b-col>
                        <b-btn variant="t-blue" @click="$utils.redirect(`#/equipment-details/?id=${registered_id}`)"
                            id="open-equipment">
                            {{ $t("Open equipment") }}
                        </b-btn>
                    </b-col>
                </b-row>
                <b-row class="text-center mt-3">
                    <b-col>
                        <b-btn variant="t-blue" @click="register_new">
                            {{ $t("Register new equipment") }}
                        </b-btn>
                    </b-col>
                </b-row>
                <br>
                <br>
            </div>
        </b-modal>
    </div>
</template>

<script>
import jsonValidation from './utils/jsonValidation'
import { getPresets } from '@/api/featureServerApi'

export default {
    data() {
        return {
            json_data: undefined,
            file_name: "",
            model: null,
            regulatory_agency: null,
            preset: null,
            models: [],
            regulatory_agencies: [],
            presets: [],
            registered_id: null,
        }
    },
    watch: {
        model(v) {
            this.regulatory_agencies = []
            this.preset = null
            this.getRegulatory()
        },
        regulatory_agency(v) {
            this.setDefaultPreset()
        }
    },
    methods: {
        getModels() {
            this.$Progress.start()
            this.$utils.request(
                'medicaldevice/devicemodel/',
                'GET',
                {},
                (r) => {
                    this.models = r.data
                    this.$Progress.finish()
                },
                () => {
                    this.$Progress.fail()
                }
            )
        },
        getRegulatory() {
            if (this.model) {
                this.$Progress.start()
                this.$utils.request(
                    `medicaldevice/regulatoryagency/?authorized_models=${this.model}`,
                    'GET',
                    {},
                    (r) => {
                        this.regulatory_agencies = r.data.results
                        this.$Progress.finish()
                        try {
                            if (r.data.results.length == 1) {
                                this.regulatory_agency = r.data.results[0].id
                            }
                        } catch (error) {
                            console.log(1)
                        }
                    },
                    () => {
                        this.$Progress.fail()
                    }
                )
            } else {
                this.$utils.customAlert(
                    'Selecione um modelo antes de escolher o modo regulatório',
                    'd'
                )
            }
        },
        setDefaultPreset() {
            // Mapeamento: modelo -> preset padrão de fábrica
            // ANVISA é o único que sai como COMPLETE; os demais saem como BASE
            const modelPresetMap = {
                'TPL-E2100-0': 'CE_BASE',
                'TPL-E2100-1': 'CE_BASE',
                'TPL-E2101-0': 'PMDA_BASE',
                'TPL-E2101-1': 'PMDA_BASE',
                'TPL-E2102-0': 'ANVISA_COMPLETE',
                'TPL-E2102-1': 'ANVISA_COMPLETE',
                'TPL-E2103-0': 'FDA_BASE',
            }
            const selectedModel = this.models.find(m => m.id === this.model)
            if (selectedModel && modelPresetMap[selectedModel.name]) {
                this.preset = modelPresetMap[selectedModel.name]
            } else {
                // Fallback genérico: selecionar o primeiro preset que contenha 'BASE' no nome,
                // ou o primeiro preset disponível caso não encontre
                const basePreset = this.presets.find(p => p.name && p.name.includes('BASE'))
                this.preset = basePreset ? basePreset.name : (this.presets[0] ? this.presets[0].name : null)
            }
        },
        //Other methods
        register_new() {
            window.location.reload()
        },
        loadPresets() {
            getPresets().then(response => {
                this.presets = response.data
            }).catch(() => {
                this.$utils.customAlert(
                    this.$t('Could not load presets from feature server'),
                    'w'
                )
            })
        },
        register() {
            if (this.model != null && this.regulatory_agency != null) {
                if (!this.preset) {
                    this.$utils.customAlert(
                        this.$t('Could not determine the default preset for this model. Please contact support.'),
                        'w'
                    )
                    return
                }
                this.$utils.request(
                    'medicaldevice/device/',
                    'POST',
                    {
                        "name": this.json_data.equipment_serial_number,
                        "serial_number": this.json_data.equipment_serial_number,
                        "pim_serial_number": this.json_data.pim_serial_number,
                        "am_serial_number": this.json_data.am_serial_number,
                        "ventilation_board_serial_number": this.json_data.ventilation_board_serial_number,
                        "pim_mac_address_one": this.json_data.pim_mac_address_one,
                        "pim_mac_address_two": this.json_data.pim_mac_address_two,
                        "regulatory_target": this.regulatory_agency,
                        "model": this.model,
                        "preset": this.preset,
                        "entity": 1,
                        "base_software": 1,
                    },
                    (r) => {
                        this.$bvModal.show('register-success')
                        this.registered_id = r.data.id
                    },
                    (r) => {
                        this.$utils.customAlert(
                            'There was an error communicating with the server',
                            'i'
                        )
                    }
                )
            } else {
                this.$utils.customAlert(
                    'Check the fields and try again',
                    'i'
                )
            }
        },
        resetForm() {
            document.getElementById("jsonfileform").reset()
            this.json_data = undefined
            this.file_name = ""
        },
        select_file() {
            var event = new MouseEvent('click', { bubbles: true })
            document.getElementById("jsonfileform").reset()
            document.getElementById("jsonfileinput").dispatchEvent(event)
            this.$Progress.set(1)
        },
        json_file_handle(test = false) {
            var file_to_read = document.getElementById("jsonfileinput").files[0]
            jsonValidation(
                file_to_read,
                (data) => {
                    this.file_name = file_to_read.name
                    this.json_data = data
                    this.$Progress.finish()
                },
                (msg = "") => {
                    this.$utils.customAlert(
                        msg,
                        'w'
                    )
                    this.resetForm()
                    this.$Progress.fail()
                }
            )
        }
    },
    created() {
        this.getModels()
        this.loadPresets()
    }
}
</script>

<style lang="scss">
.input-hidden {
    display: none;
}

.margin-json-data {
    padding: 1rem !important;
    margin-right: 1px !important;
    margin-left: 1px !important;
    margin-top: 20px !important;
}
</style>